import * as Yup from 'yup';

import { useEffect, useState } from 'react';

import FormWrapper from 'components/home/lead-form/wrapper';
import ModalBackdrop from 'core/modal-backdrop';
import PatentEmailContent from 'components/landing/lead-form/form-content/patent-email-content';
import { postLeadForm } from 'pages/api/api';
import PropTypes from 'prop-types';
import styles from 'styles/LeadForm.module.scss';
import { useCulture } from 'context/CultureContext';
import { useTranslations } from 'next-intl';

const formSteps = {
    stepOne: 'patent-email-step',
    stepTwo: 'submitted-step'
};

const schema = Yup.object().shape({
    patent: Yup.string('error-patent-invalid')
        .min(3, 'error-patent-invalid')
        .required('error-patent-required'),
    email: Yup.string('error-email-invalid')
        .email('error-email-invalid')
        .required('error-email-required')
});

const LeadFormPlateDataArba = ({ closeHandler, isVisible = null }) => {
    const { culture } = useCulture();
    const [formState, setFormState] = useState({ step: formSteps.stepOne });
    const [error, setError] = useState(null);
    const [showLoading, setShowLoading] = useState(false);
    const t = useTranslations('lead-form');

    const longTitle = {
        'patent-email-step': t('form-info'),
        'submitted-step': t('submitted-info')
    };
    const shortTitle = {
        'patent-email-step': t('form-info-short'),
        'submitted-step': t('submitted-info-short')
    };
    useEffect(() => {
        if (!isVisible) {
            setFormState({ step: formSteps.stepOne });
            setError(null);
        }
    }, [isVisible]);

    function patentEmailSubmit ({ patent, email }) {
        setError(null);
        const payload = {
            email,
            culture,
            lead_type: 'car-insurance-plate-data-arba',
            extra_data: {
                property_type: formState.type,
                patent
            }
        };

        schema
            .validate({
                email,
                patent
            })
            .then((res) => {
                setShowLoading(true);
                postLeadForm(payload, culture)
                    .then((response) => {
                        const descriptionMessage = (response.status === 201) ?
                            t('submitted-description') :
                            response.data.detail;
                        if (descriptionMessage !== null) {
                            setFormState((st) => ({
                                ...st,
                                message: descriptionMessage,
                                step: formSteps.stepTwo
                            }));
                        } else {
                            setError(t('error-validation'));
                        }
                        setShowLoading(false);
                    })
                    // eslint-disable-next-line no-console
                    .catch((_error) => {
                        setError(t('error-validation'));
                        setShowLoading(false);
                    });
            })
            .catch((e) => {
                setError(t(e.errors[0]));
                setShowLoading(false);
            });
    };

    if (!isVisible) {
        return null;
    };

    return (
        <ModalBackdrop closeHandler={closeHandler}>
            <FormWrapper
                title={
                    longTitle[formState.step] || longTitle[formSteps.stepOne]
                }
                shortTitle={
                    shortTitle[formState.step] || shortTitle[formSteps.stepOne]
                }
                errorMsg={error}
            >
                {formState.step === formSteps.stepOne && (
                    <PatentEmailContent onSubmit={patentEmailSubmit} showLoading={showLoading} />
                )}
                {formState.step === formSteps.stepTwo && (
                    <div style={{ width: '100%' }}>
                        <div
                            id="form-success"
                            dangerouslySetInnerHTML={{ __html: `<p>${formState.message}</p>` }}
                            className={styles.submitted_message} />
                    </div>
                )}
            </FormWrapper>
        </ModalBackdrop>
    );
};

LeadFormPlateDataArba.propTypes = {
    isVisible: PropTypes.bool,
    closeHandler: PropTypes.func
};

export default LeadFormPlateDataArba;
